import devLogger from 'react-utils/devLogger';
const copyWithWriteText = async text => {
  var _navigator$clipboard;
  if (typeof navigator === 'undefined' || !((_navigator$clipboard = navigator.clipboard) !== null && _navigator$clipboard !== void 0 && _navigator$clipboard.writeText)) {
    return false;
  }
  try {
    // eslint-disable-next-line compat/compat
    await navigator.clipboard.writeText(text);
    return true;
  } catch (err) {
    if (process.env.NODE_ENV !== 'production') {
      devLogger.warn({
        key: 'copyTextToClipboard Clipboard API failed',
        message: 'copyTextToClipboard: Clipboard API failed, falling back to textarea method. ' + 'This can happen in iframes or when clipboard permissions are denied.'
      });
    }
    return false;
  }
};
const copyWithTextarea = text => {
  const textarea = document.createElement('textarea');
  textarea.value = text;
  document.body.appendChild(textarea);
  try {
    textarea.select();
    textarea.setSelectionRange(0, text.length);
    return document.execCommand('copy');
  } catch (err) {
    if (process.env.NODE_ENV !== 'production') {
      devLogger.warn({
        key: 'copyTextToClipboard fallback copy failed',
        message: 'copyTextToClipboard: Both Clipboard API and textarea fallback failed to copy text.'
      });
    }
    return false;
  } finally {
    document.body.removeChild(textarea);
  }
};
export default async function copyTextToClipboard(text) {
  let success = await copyWithWriteText(text);
  if (!success) {
    success = copyWithTextarea(text);
  }
  return success;
}